import React from "react";
import CookieConsent, {
  Cookies,
  getCookieConsentValue,
} from "react-cookie-consent";
import Link from "next/link";
import { H4, StyleP } from "../../styles/base/_base.styles";
import {
  ANALYTICS_CONSENT_EVENT,
  GA_MEASUREMENT_ID,
  clearAnalyticsClientState,
} from "../../lib/analytics";

const CookieConsentComp = () => {
  const updateGoogleConsent = React.useCallback((analyticsGranted) => {
    window.dataLayer = window.dataLayer || [];
    window.gtag = window.gtag || function gtag() {
      window.dataLayer.push(arguments);
    };
    window.gtag("consent", "update", {
      ad_storage: "denied",
      analytics_storage: analyticsGranted ? "granted" : "denied",
      ad_personalization: "denied",
      ad_user_data: "denied",
    });
  }, []);

  const notifyTracker = React.useCallback((analytics) => {
    window.dispatchEvent(
      new CustomEvent(ANALYTICS_CONSENT_EVENT, { detail: { analytics } })
    );
  }, []);

  const handleAcceptCookie = React.useCallback((notify = true) => {
    updateGoogleConsent(true);
    if (notify) notifyTracker(true);
  }, [notifyTracker, updateGoogleConsent]);

  const handleDeclineCookie = React.useCallback(() => {
    updateGoogleConsent(false);
    clearAnalyticsClientState();
    Cookies.remove("_ga");
    Cookies.remove(`_ga_${GA_MEASUREMENT_ID.replace(/^G-/, "")}`);
    Cookies.remove("_gat");
    Cookies.remove("ad_storage");
    Cookies.remove("ad_user_data");
    Cookies.remove("ad_personalization");
    Cookies.remove("analytics_storage");
    notifyTracker(false);
  }, [notifyTracker, updateGoogleConsent]);

  React.useEffect(() => {
    const isConsent = getCookieConsentValue();
    if (isConsent === "true") {
      handleAcceptCookie(false);
    } else if (isConsent === "false") {
      handleDeclineCookie();
    }
  }, [handleAcceptCookie, handleDeclineCookie]);

  return (
    <CookieConsent
      onAccept={() => handleAcceptCookie(true)}
      enableDeclineButton={true}
      onDecline={handleDeclineCookie}
      declineButtonText={"Reject All"}
      flipButtons={true}
      debug={false}
      style={{
        background: "#182F35",
        width: "min(44rem, calc(100% - 2.4rem))",
        left: "1.2rem",
        bottom: "1.2rem",
        right: "auto",
        padding: "1.8rem",
        borderRadius: "0.8rem",
        boxShadow: "0 1.8rem 5rem rgba(24,47,53, 0.28)",
        alignItems: "flex-end",
      }}
      contentStyle={{ margin: "0 1.5rem 0 0", flex: "1 1 25rem" }}
      buttonStyle={{
        background: "#B5C6C1",
        color: "#182F35",
        fontSize: "13px",
        fontWeight: 700,
        minHeight: "44px",
        padding: "0 18px",
        borderRadius: "4px",
      }}
      declineButtonStyle={{
        background: "transparent",
        color: "white",
        border: "1px solid rgba(255, 255, 255, 0.7)",
        fontSize: "13px",
        fontWeight: 700,
        minHeight: "44px",
        padding: "0 18px",
        borderRadius: "4px",
      }}
      expires={90}
      buttonText={"Accept analytics"}
    >
      <H4 style={{ color: "white", fontSize: "1.8rem", marginBottom: ".5rem" }}>
        We value your privacy
      </H4>
      <StyleP style={{ fontSize: "1.35rem", lineHeight: 1.5, color: "white" }}>
        With your permission, we use analytics cookies to understand which
        destination information people find useful. You can accept or reject
        analytics cookies; essential website functions do not depend on them.
      </StyleP>

      <Link href={"/privacy-policy"}>
        <StyleP
          style={{
            cursor: "pointer",
            color: "white",
            fontSize: "1.5rem",
            textDecoration: "underline",
          }}
        >
          Cookie Policy{" "}
        </StyleP>
      </Link>
    </CookieConsent>
  );
};

export { CookieConsentComp };
